import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Carousel from 'components/common/Carousel'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { H2 } from 'components/common/Text/Text'
import RecentlyViewedItem from './components/RecentlyViewedItem'

const MAX_NUMBER_DESKTOP_ITEMS = 5
const MAX_NUMBER_MOBILE_ITEMS = 1

const generateCarouselSettingsMobile = count => ({
  slidesToScroll: 1,
  slidesToShow: MAX_NUMBER_MOBILE_ITEMS,
  dots: false,
  draggable: false,
  autoplay: false,
  arrows: count > MAX_NUMBER_MOBILE_ITEMS,
  infinite: false,
  variableWidth: false
})

const generateCarouselSettingsDesktop = count => ({
  slidesToScroll: 1,
  slidesToShow: count > MAX_NUMBER_DESKTOP_ITEMS ? MAX_NUMBER_DESKTOP_ITEMS : count,
  dots: false,
  draggable: false,
  autoplay: false,
  arrows: count > MAX_NUMBER_DESKTOP_ITEMS,
  infinite: false,
  variableWidth: false
})

const BOTRecentlyViewedProducts = ({
  recentlyViewedTireItemList = []
}) =>
  Array.isArray(recentlyViewedTireItemList) &&
  Boolean(recentlyViewedTireItemList.length) &&
    <Wrapper>
      <RecentlyViewedText data-at-heading="recently-viewed" headline headline_narrow centered>Recently Viewed</RecentlyViewedText>
      <Media.Desktop>
        <CarouselWrapper config={ generateCarouselSettingsDesktop(recentlyViewedTireItemList.length) } >
          { recentlyViewedTireItemList.map((item, index) => <RecentlyViewedItem key={ index } { ...item } />) }
        </CarouselWrapper>
      </Media.Desktop>
      <Media.Mobile>
        <CarouselWrapper config={ generateCarouselSettingsMobile(recentlyViewedTireItemList.length) } >
          { recentlyViewedTireItemList.map((item, index) => <RecentlyViewedItem key={ index } { ...item } />) }
        </CarouselWrapper>
      </Media.Mobile>
    </Wrapper>

BOTRecentlyViewedProducts.propTypes = {
  recentlyViewedTireItemList: PropTypes.arrayOf(PropTypes.shape())
}

export default BOTRecentlyViewedProducts

const Wrapper = styled.div`
  background: ${Theme.colors.off_white};
  ${Mixin.responsive('padding', '40px 0', '25px 0 25px')}
`

const RecentlyViewedText = styled(H2)`
  ${Mixin.responsive('margin', '0 0 25px', '0 0 16px')}
  ${Mixin.responsive('font-size', '26px', '20px')}
`

const CarouselWrapper = styled(Carousel)`
  max-width: 1010px;
  position: relative;
  margin: 0 auto;

  & .slick-arrow + .slick-list {
    margin: 0;
  }

  ${Media.desktop`
    & .slick-arrow {
      top: 30%;
    }
    & .slick-arrow.slick-prev {
      margin-left: -50px;
    }
    & .slick-arrow.slick-next {
      margin-right: -50px;
    }
  `}
  ${Media.mobile`
    & .slick-arrow.slick-prev {
      left: 0px;
    }
    & .slick-arrow.slick-next {
      right: 0px;
    }
    & .slick-arrow {
      top: 35%;
      width: 40px;
      height: 40px;
    }
  `}
`
